export const BASE_API_ENDPOINT = process.env.REACT_APP_API_HOST;
export const BASE_AUTH_API_HOST = process.env.REACT_APP_AUTH_API_HOST;
export const BASE_FLAG_URL = `${process.env.REACT_APP_API_HOST}/flags`;
